import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// The catalogue for one job — so the office can add an item the engineer
// missed, filtered exactly as the engineer's own form filters it.
export function useJobCatalog(discipline, jobId, enabled) {
  return useQuery({
    queryKey: ['jobCardStock', 'catalog', discipline, jobId],
    queryFn: async () => (await api.get(`/api/job-card-stock/catalog/${discipline}/${jobId}`)).data.items,
    enabled: Boolean(enabled && jobId),
    staleTime: 5 * 60_000,
  });
}

export function useJobEdits(discipline, jobId, enabled) {
  return useQuery({
    queryKey: ['jobCardStock', 'edits', discipline, jobId],
    queryFn: async () => (await api.get(`/api/job-card-stock/edits/${discipline}/${jobId}`)).data.edits,
    enabled: Boolean(enabled && jobId),
    staleTime: 0,
  });
}

// Sets a line to an exact quantity; 0 removes it. A reason is required — the
// server rejects the call without one, because a corrected figure has to stay
// distinguishable from what the engineer recorded on site.
export function useCorrectLine() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ discipline, jobId, catalogId, quantity, reason }) =>
      (await api.put('/api/job-card-stock/line', {
        discipline, job_id: jobId, catalog_id: catalogId, quantity, reason,
      })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['jobCardStock'] }),
  });
}
